module.exports = __webpack_public_path__ + "img/all_b_70121.fdd29c5c.jpg";